<template>
  <div class="hello">
    <QuizList></QuizList>
  </div>
</template>

<script>
import QuizList from '@/components/cubbily-quiz/QuizList';

export default {
  name: 'Normal',
  components: {
    QuizList
  },
  props: {

  },
  data () {
    return {

    };
  },

  methods: {
  },

  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeDestroy () {},
  destroyed () {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
